import { Injectable } from '@angular/core';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { AbstractControl, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PhoneValidatorService {
  phoneNumberUtil = PhoneNumberUtil.getInstance();

  phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      let validNumber = false;
      let validType = false;

      try {
        const phoneNumber = this.phoneNumberUtil.parseAndKeepRawInput(
          control.value.number, control.value.countryCode
        );

        validNumber = this.phoneNumberUtil.isValidNumber(phoneNumber);
        validType = this.checkTypeNumberMobile(phoneNumber);
      } catch (e) {
      }
      return validNumber && validType ? null : { wrongNumber: { value: control.value } };
    };
  }

  digitOnly(event: KeyboardEvent): void {
    const input = event.key;

    if (event.key !== 'Backspace') {
      if (!/^[0-9+]*$/.test(input)) {
        event.preventDefault();
      }
    }
  }

  private checkIfIsSpecialNumber(phoneNumber: any): boolean {
    const regex = /^[8,9]/;

    return !regex.test(phoneNumber);
  }

  private checkTypeNumberMobile(phoneNumber: any) {
    const typeNumber = this.phoneNumberUtil.getNumberType(phoneNumber);
    return typeNumber === 1
  }
}
